const CODE_ASSIGNMENT_REQUEST = 'CODE_ASSIGNMENT_REQUEST';
const CODE_ASSIGNMENT_SUCCESS = 'CODE_ASSIGNMENT_SUCCESS';
const CODE_ASSIGNMENT_FAILURE = 'CODE_ASSIGNMENT_FAILURE';

export {
  CODE_ASSIGNMENT_REQUEST,
  CODE_ASSIGNMENT_SUCCESS,
  CODE_ASSIGNMENT_FAILURE,
};
